import React from 'react';
import classNames from "classnames";

import Framework from "@beardeddevops/react.framework"
import {Objects} from "components";

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import UserRoles from "../../../../../constants/UserRoles";
import {Button} from "reactstrap";

const breadcrumbsStatic = [{
	name: 'Schedule Adjustments',
	url: '/schedule_adjust',
	icon: 'map',
}];

export default class Time_Off extends Framework.Components.View {

	constructor(props) {
		super(props, 'details');
	}

	render() {
		let {match, history, baseUrl, reloadShell, user, main_role} = this.props;
		let {name} = this.state;

		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name,
				url: `/schedule_adjust/${match.params.id}`,
				icon: 'map-marker',
			}
		]);

		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={history}/>

				<Objects.TimeOffRequest
					id={match.params.id}
					history={history}
					reloadShell={reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					updateName={this.updateName}
					baseUrl={baseUrl}
					goBack={true}
					user={user}
					noDelete={false}
					main_role={main_role}
				/>

			</div>
		)
	}
};